import $ from 'jquery';

$(document).ready(() => {
    $(".product_link_nav.with_preview a").hoverIntent({    
        sensitivity: 3, 
        interval: 0, 
        timeout: 0
    }).hoverIntent(function(){
            $(this).find('.product_link_nav_preview').show();
        },function(){
            $(this).find('.product_link_nav_preview').hide();
        });
});



// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js


// WEBPACK FOOTER //
// ./js/stproductlinknav.js